
import React, { useEffect } from 'react';
import './HeroCarousel.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const slides = [
  {
    img: '/assets/Driver.png',
    subtitle: 'One Ride At A Time',
    desc: "Whether it's corporate travel or personal adventures, JP Travel Enterprises delivers transportation."
  },
  {
    img: '/assets/Client1.png',
    subtitle: 'Our Commitment',
    desc: "Experience luxurious and reliable travel, customized to fit your schedule. Let us take the wheel while you relax."
  },
  {
    img: '/assets/Client2.png',
    subtitle: 'Powered By Service',
    desc: "We take pride in offering safe, comfortable, and dependable transportation for every occasion."
  }
];

const HeroCarousel = () => {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      easing: 'ease-in-out',
      once: true,
      offset: 200,
    });
  }, []);

  return (
    <div
      id="heroCarousel"
      className="carousel slide carousel-fade"
      data-bs-ride="carousel"
      data-bs-interval="3000"
    >
      <div className="carousel-inner">
        {slides.map((slide, index) => (
          <div
            className={`carousel-item hero-slide ${index === 0 ? 'active' : ''}`}
            key={index}
            style={{ backgroundImage: `url(${slide.img})` }}
          >
            {/* <div className="overlay"></div> */}
            <div className="container h-100 d-flex align-items-center">
              <div className="row w-100">
                {/* Left Side - Form */}
                <div className="col-sm-4 col-md-4 mobileview">
                  <div className="intro-form bg-white p-4 ">
                    <h4 className='fontroboto'>Book your ride from Trusted </h4>
                    <form action="submit.php" method="POST">
                      <input name="form-type" value="contact" type="hidden" />
                      <fieldset>
                        <input placeholder="Name" required type="text" name="name" />
                        <input
                          placeholder="Mobile No."
                          type="tel"
                          name="mobile"
                          className="form-control"
                          minLength="10"
                          maxLength="15"
                          required
                        />
                        <button className="btn btn-block btn-lg btn-warning" type="submit">
                          Submit Now
                        </button>
                      </fieldset>
                    </form>
                  </div>
                </div>
                {/* Right Side - Carousel Content */}
                <div className="col-sm-8 col-md-8 hero-content-wrapper text-white d-none" data-aos="zoom-in">
                  <div className="content-inner">
                    <h1 className="highlight fw-bold mb-3">{slide.subtitle}</h1>
                    <p className="lead mb-4">{slide.desc}</p>
                    <div className="d-flex gap-3">
                      <button className="btn btn-warning px-4 py-2 fw-bold ">BOOK A RIDE</button>
                      <button className="btn btn-outline-light px-4 py-2 fw-bold">CONTACT US</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Indicators (Dots) */}
      <div className="carousel-indicators d-md-none">
  {slides.map((_, index) => (
    <button
      key={index}
      type="button"
      data-bs-target="#heroCarousel"
      data-bs-slide-to={index}
      className={index === 0 ? 'active' : ''}
      aria-current={index === 0 ? 'true' : undefined}
      aria-label={`Slide ${index + 1}`}
    ></button>
  ))}
</div>


      {/* Navigation buttons for desktop only */}
      <button className="carousel-control-prev d-none d-md-block" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
        <span className="carousel-control-prev-icon bg-dark rounded" />
      </button>
      <button className="carousel-control-next d-none d-md-block" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
        <span className="carousel-control-next-icon bg-dark rounded" />
      </button>
    </div>
  );
};

export default HeroCarousel;


// import React, { useEffect } from 'react';
// import './HeroCarousel.css';
// import AOS from 'aos';
// import 'aos/dist/aos.css';

// const slides = [
//   {
//     img: '/assets/Driver.png',
//     subtitle: 'One Ride At A Time',
//     desc: "Whether it's corporate travel or personal adventures, JP Travel Enterprises delivers transportation."
//   },
//   {
//     img: '/assets/Client1.png',
//     subtitle: 'Our Commitment',
//     desc: "Experience luxurious and reliable travel, customized to fit your schedule. Let us take the wheel while you relax."
//   },
//   {
//     img: '/assets/Client2.png',
//     subtitle: 'Powered By Service',
//     desc: "We take pride in offering safe, comfortable, and dependable transportation for every occasion."
//   }
// ];

// const HeroCarousel = () => {
//   useEffect(() => {
//     AOS.init({
//       duration: 1500,
//       easing: 'ease-in-out',
//       once: true,
//       offset: 200,
//     });
//   }, []);

//   return (
//     <div
//       id="heroCarousel"
//       className="carousel slide carousel-fade"
//       data-bs-ride="carousel"
//       data-bs-interval="3000"
//     >
//       <div className="carousel-inner">
//         {slides.map((slide, index) => (
//           <div
//             className={`carousel-item hero-slide ${index === 0 ? 'active' : ''}`}
//             key={index}
//             style={{ backgroundImage: `url(${slide.img})` }}
//           >
//             <div className="overlay"></div>
//             <div className="container h-100 d-flex align-items-center justify-content-start">
//           <div className="col-sm-4 col-md-4 mobileview" data-aos="zoom-in">
//             <div className="intro-form bg-white p-4 rounded shadow">
//               <h4>Book You Ride from Trusted </h4>
//               <form action="submit.php" method="POST">
//                 <input name="form-type" value="contact" type="hidden" />
//                 <fieldset>
//                   <input placeholder="Name" required type="text" name="name" className="form-control mb-3" />
//                   <input
//                     placeholder="Mobile No."
//                     type="tel"
//                     name="mobile"
//                     className="form-control mb-3"
//                     minLength="10"
//                     maxLength="15"
//                     required
//                   />
//                   <button className="btn btn-block btn-lg btn-orange w-100" type="submit">
//                     Submit Now
//                   </button>
//                 </fieldset>
//               </form>
//             </div>
//           </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Mobile Indicators (Dots) */}
//       <ol className="carousel-indicators d-md-none">
//         {slides.map((_, index) => (
//           <li
//             key={index}
//             data-bs-target="#heroCarousel"
//             data-bs-slide-to={index}
//             className={index === 0 ? 'active' : ''}
//           ></li>
//         ))}
//       </ol>

//       {/* Navigation buttons for desktop only */}
//       <button className="carousel-control-prev d-none d-md-block" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
//         <span className="carousel-control-prev-icon bg-dark rounded" />
//       </button>
//       <button className="carousel-control-next d-none d-md-block" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
//         <span className="carousel-control-next-icon bg-dark rounded" />
//       </button>
//     </div>
//   );
// };

// export default HeroCarousel;